import { render } from "./NordenTable.vue?vue&type=template&id=73057078"
import script from "./NordenTable.vue?vue&type=script&lang=js"
export * from "./NordenTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__